import React from "react";
import IoClose from "react-icons/lib/io/android-close";
import {useTranslation} from "@unibuddy/intl";

export default function CloseIcon(props) {
    const {t} = useTranslation("common");
    return <IoClose {...props} alt={t("close", "Close")} />;
}
